export default __webpack_public_path__ + "static/media/overlay_background_1.cbf1024a.png";